import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {SubmitInboxEnrollmentForm as SubmitInboxEnrollmentFormMutation} from 'nutshell-graphql-types';

import SUBMIT_FORM from '../mutations/submit-enrollment-form.graphql';

export function useSubmitEnrollmentForm(): {
    submitEnrollmentForm: () => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [enrollmentFormSubmit, {loading: isLoading, error}] = useMutation<
        SubmitInboxEnrollmentFormMutation,
        Record<any, any>
    >(SUBMIT_FORM);

    return {
        submitEnrollmentForm: enrollmentFormSubmit,
        isLoading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
